<template>
    <div class="container">
        <Item :width="528" :height="640" :title="'发电站概况'">
            <div class="dataitem_container"
                style="display: flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;">
                <DataItem :title="'总电站'" :data="'2 座'">
                    <div style="font-size:18rem;display:flex;flex-direction:row;justify-content:space-between;">
                        <div>健康 <span style="color: #0D94FF;">2座</span></div>
                        <div>异常 <span style="color: #FD4238;">0座</span></div>
                    </div>
                </DataItem>
                <DataItem :title="'今日总发电量'" :data="816" :unit="'kWh'" />
                <DataItem :title="'总装机容量'" :data="129" :unit="'kWp'" />
                <DataItem :title="'本月发电量'" :data="17052" :unit="'kWh'" />
                <DataItem :title="'今日最高等效'" :data="3.23" :unit="'h'" />
                <DataItem :title="'累计总发电量'" :data="192047" :unit="'kWh'" />
            </div>
        </Item>
        <Item :width="1064" :height="640" :title="'近15日发电用电趋势图'">
            <div class="dataitem_container">
                <Chart :barData="barData"></Chart>
            </div>
        </Item>
        <Item :width="528" :height="312" :title="'累计环保贡献'">
            <div class="dataitem_container">
                <LineItem :icon="require('../../assets/img/二氧化碳.png')" :title="'减少碳排量CO2'" :data="191424"
                    :unit="'kg'" />
                <LineItem :icon="require('../../assets/img/煤.png')" :title="'节约标准煤'" :data="76784" :unit="'kg'" />
                <LineItem :icon="require('../../assets/img/树.png')" :title="'相当于植树'" :data="479" :unit="'棵'" />
            </div>
        </Item>
        <Item :width="1064" :height="312" :title="'单电站发电详情'" :describe="'共2个电站'">
            <div class="dataitem_container"
                style="display: flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;align-items: center;">
                <CircleItem :id="1" :current="6.2" :title="'光伏电站1'" :today="136" :all="32008" />
                <CircleItem :id="2" :current="8.4" :title="'光伏电站2'" :today="680" :all="160039" />
            </div>
        </Item>
    </div>
</template>

<script>
    import Item from './item.vue'
    import DataItem from './dataitem.vue'
    import Chart from './Chart.vue'
    import LineItem from './lineitem.vue'
    import CircleItem from './circleitem.vue'
    export default {
        name: "PVPower",
        components: {
            Item,
            DataItem,
            Chart,
            LineItem,
            CircleItem,
        },
        data() {
            return {
                nameArr: ['6/10', '6/11', '6/12', '6/13', '6/14', '6/15', '6/16', '6/17', '6/18', '6/19', '6/20',
                    '6/21', '6/22', '6/23', '6/24'
                ],
                valueArr: [555, 690, 650, 410, 750, 780, 740, 180, 40, 190, 220, 810, 960, 980, 816],
            }
        },
        created() {
            this.nameArr = this.getPre14DayNew(15)
        },
        methods: {
            getPre14DayNew(fate) {
                var time_data = [];
                for (var i = 0; i < fate; i++) {
                    let dd = new Date()
                    dd.setDate(dd.getDate() + (0 - i));
                    var y = dd.getFullYear();
                    var m = dd.getMonth() + 1;
                    if (m < 10) {
                        m = '0' + m;
                    }
                    var d = dd.getDate();
                    if (d < 10) {
                        d = '0' + d;
                    }
                    time_data[i] = m + "/" + d;
                }
                return time_data.reverse();
            },
            test(percentage) {
                return '当前功率'
            }
        },
        computed: {
            barData: function () {
                return this.nameArr.map((item, index) => {
                    return {
                        name: this.nameArr[index],
                        value: this.valueArr[index],
                        itemStyle: {
                            color: '#B0E6FF'
                        }
                    }
                })
            },
        }
    }
</script>

<style lang="less" scoped>
    .container {
        .w(1700);
        .h(976);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .dataitem_container {
            width: 100%;
            height: 100%;
        }
    }
</style>